import React from "react";
import { Prism as ReactSyntaxHighlighter } from "react-syntax-highlighter";
import { atomDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import cssVariables from "config/variables.scss";

function CodeRenderer(props) {
  const { value, codingLanguage, transparent } = props;
  const language = codingLanguage ? codingLanguage :  props.language;
  let customStyle = {
    borderWidth: "0",
    borderRadius: "0",
    margin: "0px",
    marginBottom: "1rem",
    fontSize: "14px",
    background: cssVariables.buttonBackground,
  };

  transparent && Object.assign(customStyle,{
    background: "none",
    padding: 0,
    marginBottom: 0,
  });

  return (
    <ReactSyntaxHighlighter
      style={atomDark}
      customStyle={customStyle}
      language={language}
      wrapLines={true}
      lineProps={(lineNumber) => ({
        style: { display: "block", whiteSpace: "pre-wrap" },
      })}
    >
      {value}
    </ReactSyntaxHighlighter>
  );
}

const CodeRendererWithTransparentBackground = props => 
  <CodeRenderer {...props} transparent />

export { CodeRenderer, CodeRendererWithTransparentBackground };
